import circlesBg from 'assets/bgWhite.png';
import banner from 'assets/banner.png';
import bgImg from 'assets/bgIMG.png';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  circlesBg,
  banner,
  bgImg,
};
